import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "iodine-references-header" }
const _hoisted_2 = { class: "references-option" }
const _hoisted_3 = { class: "references-search-bar" }

import { onMounted, ref } from 'vue';
import { ReferencesBook } from 'src/services/TrucodeReferencesService';
import { useTrucodeReferenceStore } from 'stores/TrucodeReferenceStore';
import DropDown from 'components/global-common/DropDown.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesHeader',
  emits: ["referencesOptionChanged", "bookChanged", "searchTextChanged", "searchAction"],
  setup(__props, { emit: __emit }) {

const referencesOption = ref('search');

const searchOption = ref<string | null>(null);
const browseOption = ref<string | null>(null);
const text = ref('');
const bookReferences = ref<ReferencesBook[] | undefined>([]);

const emit = __emit

onMounted(async () => {
  const result = await useTrucodeReferenceStore().getBookReference();
  bookReferences.value = result || [];
})

function bookChanged(referencesBook: ReferencesBook) {
  emit('bookChanged', referencesBook);
}

function referencesOptionChanged(value: string) {

  emit('referencesOptionChanged', value)
}

return (_ctx: any,_cache: any) => {
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_radio, {
        modelValue: referencesOption.value,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((referencesOption).value = $event)),
          referencesOptionChanged
        ],
        val: "search",
        label: "Search"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_q_radio, {
        modelValue: referencesOption.value,
        "onUpdate:modelValue": [
          _cache[1] || (_cache[1] = ($event: any) => ((referencesOption).value = $event)),
          referencesOptionChanged
        ],
        val: "browse",
        label: "Browse"
      }, null, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createVNode(DropDown, {
        modelValue: searchOption.value,
        "onUpdate:modelValue": [
          _cache[2] || (_cache[2] = ($event: any) => ((searchOption).value = $event)),
          bookChanged
        ],
        options: bookReferences.value,
        "option-label": "title",
        "option-value": "id",
        label: "Book",
        "class-name": "references-book"
      }, null, 8, ["modelValue", "options"]), [
        [_vShow, referencesOption.value === 'search']
      ]),
      _withDirectives(_createVNode(DropDown, {
        modelValue: browseOption.value,
        "onUpdate:modelValue": [
          _cache[3] || (_cache[3] = ($event: any) => ((browseOption).value = $event)),
          bookChanged
        ],
        options: _unref(useTrucodeReferenceStore)().getBrowseOptions(),
        "option-label": "title",
        "option-value": "id",
        label: "Book",
        class: "references-book"
      }, null, 8, ["modelValue", "options"]), [
        [_vShow, referencesOption.value === 'browse']
      ]),
      _createVNode(_component_q_input, {
        dense: "",
        outlined: "",
        modelValue: text.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((text).value = $event)),
        label: "Search for a term or code...",
        class: "references-search",
        for: "references-search",
        disable: referencesOption.value !== 'search' || !searchOption.value
      }, {
        append: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_icon, {
            name: "fa-regular fa-xmark",
            class: "cursor-pointer",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (text.value = ''))
          }, null, 512), [
            [_vShow, text.value !== '']
          ]),
          _createVNode(_component_q_separator, {
            vertical: "",
            inset: "true"
          }),
          _createVNode(_component_q_icon, { name: "fa-regular fa-magnifying-glass" })
        ]),
        _: 1
      }, 8, ["modelValue", "disable"])
    ])
  ]))
}
}

})